import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";

const Container = styled.div`
    width: 400px;
    padding-bottom: 30px;

    ${device.tablet} {
        width: 100%;
        max-width: 600px;
    }
`;
const EngTitle = styled.span`
    font-size: 24px;
    line-height: 36px;
    letter-spacing: -0.6px;
    display: inline-block;
    font-weight: 300;

    ${device.mobile} {
        font-size: 18px;
    }
`;
const KoTitle = styled.strong`
    font-size: 32px;
    line-height: 40px;
    display: block;
    letter-spacing: -1.5px;
    font-weight: 800;

    ${device.mobile} {
        font-size: 22px;
        line-height: 22px;
        font-weight: 800;
    }
`;
const SubTitle = styled.p`
    display: block;
    margin-top: 10px;
    font-size: 20px;
    font-weight: normal;
    letter-spacing: -1px;

    ${device.mobile} {
        font-size: 14px;
    }
`;
const Line = styled.div`
    border-bottom: 1px solid #777;
    padding-bottom: 30px;
    height: 1px;
    width: 200px;

    ${device.mobile} {
        border-bottom: 1px solid #999;
        max-width: 100vw;
        width: 50%;
        margin-top: 10px;
        padding-bottom: 5px;
    }
`;
const SectionTitle = ({title, enTitle, subTitle}) => {
    return (
        <Container>
            <EngTitle>{enTitle}</EngTitle>
            <KoTitle>{title}</KoTitle>
            {subTitle && <SubTitle>{subTitle}</SubTitle>}
            <Line />
        </Container>
    );
};

export default SectionTitle;
